<template>
  <div class="navbar flex_between">
    <div class="flex_middle">
      <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper" title="点击切换主体">
          <div class="cf">{{ userinfo.company_name + ' ( ' + userinfo.channel_name + ' ) ' }} <i class="el-icon-arrow-down" /></div>
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <el-dropdown-item v-for="(item) in userinfo.other_company" @click.native="changeCompany(item.company_id)" title="点击切换"><div>{{ item.company_name + ' ( ' + item.channel_name + ' ) ' }}</div></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- <breadcrumb class="breadcrumb-container" /> -->
    <div class="right-menu">
      <div class="notify mr40 pointer">
        <el-badge :value="noRead" :hidden="!noRead" :max="99">
          <svg-icon icon-class="notify" @click="goMsg" />
        </el-badge>
      </div>
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar">
          <span class="user-name">{{ userinfo.nickname || '游客' }}</span>
          <i class="el-icon-arrow-down" />
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <el-dropdown-item @click.native="changePassword">
            修改密码
          </el-dropdown-item>
          <el-dropdown-item @click.native="logout">
            <span style="display:block;">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <edit-password :visible.sync="editPassDialog" @submit="submitEdit" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import EditPassword from './EditPassword'

export default {
  components: {
    // Breadcrumb,
    Hamburger,
    EditPassword
  },
  data() {
    return {
      company_id: 0,
      avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
      editPassDialog: false
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'userinfo'
    ]),
    ...mapGetters('user', [
      'noRead'
    ])
  },
  created() {
    this.company_id = this.$store.getters.userinfo.company_id
  },
  mounted() {
    this.getNoReadNotice()
    this.timer = setInterval(() => {
      this.syncCompany()
      if (this.company_id !== this.$store.getters.userinfo.company_id) {
        location.reload()
      }
    }, 3000)
  },
  methods: {
    ...mapActions('user', ['getNoReadNotice', 'switchCompany', 'syncCompany']),
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login`)
    },
    changePassword() {
      this.$store.dispatch('user/getPhoneFn')
      this.editPassDialog = true
    },
    submitEdit() {
      this.$router.push(`/login`)
    },
    goMsg() {
      this.$router.push('/msg/index')
    },
    async changeCompany(company_id) {
      const res = await this.switchCompany({ company_id: company_id })
      if (res.code === 200) {
        this.$message.success('切换主体成功')
        setTimeout(() => {
          location.reload()
        }, 1000)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #2D8CF0;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
  padding: 0px 30px;
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    // float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;
    color: white !important;
    // &:hover {
    //   background: rgba(0, 0, 0, .025)
    // }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    // float: right;
    height: 100%;
    line-height: 50px;
    display: flex;
    color: white !important;
    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: white;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;
      color: white !important;
      .avatar-wrapper {
        // margin-top: 5px;
        position: relative;
        display: flex;
        align-items: center;
        cursor: pointer;

        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          font-size: 16px;
        }
        .user-name{
          margin: 0 8px;
        }
      }
    }
  }
  .notify{
    .svg-icon{
      width: 24px;
      height: 24px;
    }
  }
}
::v-deep{
  .notify{
    .el-badge__content.is-fixed{
      top: 15px;
    }
  }
}
</style>
